import Vue from "vue";
import Router from "vue-router";
import moment from "moment";
import AuthRoutes from "./views/pages/Auth/routes";
import DashRoutes from "./views/pages/Dash/routes";
import ClientRoutes from "./views/pages/Clients/routes";
import ResalesRoutes from "./views/pages/Resales/routes";
import ProductsResaleRoutes from "./views/pages/ProductsResale/routes";
import ProductsRoutes from "./views/pages/Products/routes";
import InstallersRoutes from "./views/pages/Installers/routes";
import UsersRoutes from "./views/pages/Users/routes";
import UserConfigRoutes from "./views/pages/UserConfig/routes";
import MarketingRoutes from "./views/pages/Marketing/routes";
import OrdersRoutes from "./views/pages/Orders/routes";
import ResaleStockRoutes from "./views/pages/ResaleStock/router.js";
import PromotionsCenter from "./views/pages/PromotionsCenter/router.js";
import PromotionsCenterResale from "./views/pages/PromotionsCenterResale/router.js";
import DashResaleRoutes from "./views/pages/DashResale/routes";
import NewsFeedRoutes from "./views/pages/NewsFeed/router.js";
import NewsRoutes from "./views/pages/News/routes";
import CommonQuestionsRoutes from "./views/pages/CommonQuestions/router";
import LogsRoutes from "./views/pages/Logs/router";
import FinancialRoutes from "./views/pages/FinancialResale/routes";
import SalesRoutes from "./views/pages/Sales/routes";
import CoursesRoutes from "./views/pages/Courses/routes";

Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  mode: "history",
  routes: [
    {
      path: "/dash-resale",
      ...DashResaleRoutes,
    },
    {
      path: "/auth",
      ...AuthRoutes,
    },
    {
      path: "/resale-stock",
      ...ResaleStockRoutes,
    },
    {
      path: "/promotions-center",
      ...PromotionsCenter,
    },
    {
      path: "/feed-noticias",
      ...NewsFeedRoutes,
    },
    {
      path: "/noticias",
      ...NewsRoutes,
    },
    {
      path: "/logs",
      ...LogsRoutes,
    },
    {
      path: "/financial",
      ...FinancialRoutes,
    },
    {
      path: "/vendas",
      ...SalesRoutes,
    },
    {
      path: "/cursos",
      ...CoursesRoutes,
    },
    {
      path: "/perguntasFrequentesAdmin",
      ...CommonQuestionsRoutes,
    },
    {
      path: "/promotions-center-resale",
      ...PromotionsCenterResale,
    },
    {
      path: "/dash",
      ...DashRoutes,
    },
    {
      path: "/resales",
      ...ResalesRoutes,
    },

    {
      path: "/products",
      ...ProductsRoutes,
    },
    {
      path: "/products",
      ...ProductsResaleRoutes,
    },
    {
      path: "/installers",
      ...InstallersRoutes,
    },
    {
      path: "/users",
      ...UsersRoutes,
    },
    {
      path: "/orders",
      ...OrdersRoutes,
    },
    {
      path: "/clients",
      ...ClientRoutes,
    },
    {
      path: "/marketing",
      ...MarketingRoutes,
    },
    {
      path: "/userConfig",
      ...UserConfigRoutes,
    },
    {
      path: "/",
      redirect: "/auth",
    },
    {
      path: "/user",
      name: "/user",
      redirect: "/auth",
      meta: {
        requiresMaster: true,
      },
    },
    {
      path: "*",
      redirect: "/auth",
    },
    {
      path: "/404",
      component: () => import("@/views/pages/Index"),
      children: [
        {
          name: "404 Error",
          path: "",
          component: () => import("@/views/pages/Error"),
        },
      ],
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  let token = localStorage.getItem("token");
  let expiresToken = localStorage.getItem("expires");
  let user = JSON.parse(localStorage.getItem("user"));
  if (to.meta.requiresAuth) {
    if (token) {
      if (moment().isBefore(moment(expiresToken))) {
        if (user.type == 0 && to.meta.requiresMaster) {
          next();
        } else if (user.type == 1 && to.meta.requiresAdmin) {
          next();
        } else if (user.type == 2 && to.meta.requiresResale) {
          next();
        } else if (user.type == 3) {
          next();
        } else if (user.type == 5 && to.meta.requiresFinancial) {
          next();
        } else if (user.type == 6 && to.meta.requiresMarketing) {
          next();
        } else if (user.type == 7 && to.meta.requiresManagerial) {
          next();
        } else if (user.type == 8 && to.meta.requiresImprimaxtec) {
          next();
        } else {
          if (from.path != "/auth") {
            next("/auth");
          }
          alert("Acesso Restrito");
        }
      } else {
        next("/auth");
      }
    } else {
      next("/auth");
    }
  } else {
    next();
  }
});

export default router;
